import React from "react";
import { AudioItem } from "../components/audio-item/AudioItem";

export function SkinNames() {
  return (
    <div className="page">
      <AudioItem
        filePath={"./audio/skin_names/ngudda_baleh_kunkurlah.mp3"}
        kwText={"Ngudda baleh kunkurlah?"}
        enText={"What's your skin name?"}
      />
      <AudioItem
        filePath={"./audio/skin_names/ngaye_kunkurlah_ngardu_ngalwakadj.mp3"}
        kwText={"Ngaye kunkurlah ngardduk Ngalwakadj."}
        enText={"My skin name is Ngalwakadj."}
      />
    </div>
  );
}
